export default __webpack_public_path__ + "static/media/dark_mode.161489be.svg";